import { render, staticRenderFns } from "./SonEntityContainer.vue?vue&type=template&id=0c2ac568"
import script from "./SonEntityContainer.vue?vue&type=script&lang=js"
export * from "./SonEntityContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports